import axios from "axios";
import axiosInstance from "../../../Utils/axios";
import { paginationQueryParams } from "../../../Utils/paginationParam";
let cancelToken;

const docNumberingURL = "/api/v1/core-app/document-numbering/list-for-sequence-numbering";

//obtaining the paginated data

//obtaining the paginated data
export const getDocNumbering = ({ type, branchId, interBranch }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${docNumberingURL}?id=&series=&document_type=${type}&branch=${branchId}&for_inter_branch_transaction=${interBranch}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
